import type { Credential } from "../types";

/**
 * A blank instance of a credential's type — the type, its label and its
 * requirement, with none of the values.
 *
 * `credentialId: null` and `present: false` are what put the edit modal into
 * create mode, so saving mints a new anchor rather than a new version of
 * whichever instance happened to be on screen. Every "add another" affordance
 * builds one of these, so they all agree on what "blank" means.
 *
 * `idSuffix` only has to make the React key unique among the cards rendered
 * beside it; nothing reads it back.
 */
export function blankCredentialInstance(
  template: Credential,
  idSuffix: string,
): Credential {
  return {
    ...template,
    id: `${template.credentialType}:${idSuffix}`,
    credentialId: null,
    requirementSatisfiedBy: null,
    present: false,
    verified: false,
    status: "missing",
    expiryStatus: null,
    identityKey: null,
    summary: null,
    version: null,
    documents: [],
    verifications: [],
  };
}
